(() => {
    let mobileAccordion = document.querySelectorAll('.mobile-accordion');

    const initStateReady = () => {
        if (mobileAccordion) {
            mobileAccordion.forEach((accordionItem) => {
                accordionItem.addEventListener('click', function (event) {
                    toggleAccordion(this);
                });
            });
        }
    };

    const toggleAccordion = (accordionItem) => {
        // rotate icon after click
        accordionItem.querySelector('.svg-icon').classList.toggle('rotate-45');
        // show up content
        document.querySelector('#' + accordionItem.getAttribute('data-dropdown-id')).classList.toggle('show');
    };

    document.addEventListener('readystatechange', () => {
        if (document.readyState !== 'complete') return;

        initStateReady();
    });
})();
